
import session from '@/base/model/session'
import { defineAsyncComponent } from 'vue'

const system = {
  apps: []
}

session.system = system
export default system